import type { ReactNode, ComponentType, FC } from 'react';
import ErrorBoundary from '../error-boundary';
import ErrorBoundaryFallbackInline from './ErrorBoundaryFallbackInline';

type ErrorBoundaryInlineProps = {
  wrapper?: ComponentType<{ children: ReactNode }>;
  children?: ReactNode;
};

/**
 * Mount an error boundary that will render an inline error with modal stack trace.
 * @see ErrorBoundaryPage if you do not need an inline fallback.
 */
const ErrorBoundaryInline: FC<ErrorBoundaryInlineProps> = ({
  wrapper: Wrapper,
  children,
  ...props
}) => {
  let fallback = ErrorBoundaryFallbackInline;
  if (Wrapper) {
    fallback = (innerProps) => (
      <Wrapper>
        <ErrorBoundaryFallbackInline {...innerProps} />
      </Wrapper>
    );
  }

  return (
    <ErrorBoundary {...props} FallbackComponent={fallback}>
      {children}
    </ErrorBoundary>
  );
};

export default ErrorBoundaryInline;
